/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @sfdc-extension-file SFDC_EXT_SHIPPING_DELIVERY */
import { Suspense, lazy, type ReactElement } from 'react';
import { Await } from 'react-router';
import { useShippingDelivery } from '@/extensions/shipping-delivery/context/shipping-delivery-context';

const EstimatedDelivery = lazy(() => import('@/extensions/shipping-delivery/components/estimated-delivery'));

export default function EstimatedDeliveryTarget(): ReactElement | null {
    const ctx = useShippingDelivery();
    if (!ctx) return null;

    return (
        <Suspense fallback={null}>
            <Await resolve={ctx.estimatedDeliveryPromise} errorElement={null}>
                {(data) => <EstimatedDelivery data={data} />}
            </Await>
        </Suspense>
    );
}
